module.exports = __webpack_public_path__ + "img/PS-M-18.da48ad31.svg";